import React from 'react'
import { sum } from 'lodash-es'
import { Rose } from '@ow/charts/lib'
import { Table } from '@mantine/core'

const BASE_CLOUMNS = [
  { title: '选项名称', slug: 'title' },
  { title: '数量', slug: 'num' },
  { title: '占比', slug: 'ratio' },
]
const Statistics = function ({ opts, extCloumns = [], data }) {
  const { selects } = opts
  const allCloumns = BASE_CLOUMNS.concat(extCloumns || [])
  const allNum = sum((data || []).map((v) => v.num))
  const allData = (selects || []).map((v) => {
    const currentData = (data || []).find((d) => d.slug === v.slug) || {}

    return {
      ...currentData,
      title: v.title,
      num: currentData.num || 0,
      ratio:
        (currentData.num
          ? String(
              Math.round((Number(currentData.num) / Number(allNum)) * 10000) /
                100
            )
          : '0') + '%',
    }
  })

  return (
    <div className="h-full w-full flex flex-col items-center">
      <div className="flex-1 w-full relative">
        <div
          className="absolute top-0 left-0 w-full h-full flex items-center justify-center font-semibold"
          style={{ fontSize: '20px' }}
        >
          {allNum.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}
        </div>
        <Rose
          className="w-full"
          height={300}
          id="dropSelect"
          data={(data || []).map((v) => {
            const obj = (selects || []).find((m) => m.slug === v.slug) || {}
            return { name: obj.title, value: v.num }
          })}
          colors={selects.map((v) => v.color)}
          showLabel={false}
          showLegend={false}
        />
      </div>
      <div
        className="w-full overflow-auto"
        style={{ height: 'calc(100% - 300px)' }}
      >
        <Table className="w-full relative" fontSize="sm" verticalSpacing="xs">
          <thead
            style={{
              background: '#F5F9FF',
              width: '100%',
              position: 'sticky',
              top: '0',
              left: '0',
            }}
          >
            <tr style={{ width: '100%' }}>
              {allCloumns.map((v) => {
                return <th style={{ fontSize: '13px' }}>{v.title}</th>
              })}
            </tr>
          </thead>
          <tbody
            style={{ height: 'calc(100% - 50px)', width: '100%' }}
            className="overflow-y-auto"
          >
            {allData.map((item) => (
              <tr key={item.name} style={{ width: '100%' }}>
                {allCloumns.map((v) => {
                  return (
                    <td
                      title={item[v.slug]}
                      style={{ maxWidth: '200px', fontSize: '13px' }}
                    >
                      {item[v.slug]}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default Statistics
